module.exports = __webpack_public_path__ + "media/application/images/svgs/download-cloud-88fcc6185b0dee9a1678cf83d4b60860.svg";